"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Organization = void 0;
const ModelCommon_1 = require("./ModelCommon");
const Address_1 = require("./commonAttributeSets/Address");
const DefaultContactDetails_1 = require("./commonAttributeSets/DefaultContactDetails");
const typeName = 'Organization';
const { dwelling_number, ...AddressLess } = Address_1.Address;
class Organization extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(ob.type || typeName, ob);
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            ...AddressLess,
            ...DefaultContactDetails_1.DefaultContactDetails,
        };
    }
}
exports.Organization = Organization;
